import r from"antd/lib/breadcrumb";export*from"antd/lib/breadcrumb";var a=r.Item,t=r.Separator,b=r;export{b as Breadcrumb,a as BreadcrumbItem,t as BreadcrumbSeparator};
